/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-05-15 16:18:32
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-25 13:45:04
 */

export default {
    path: 'customer',
    component: () => import(/* webpackChunkName: "customer-list" */ '@/pages/customer/List'),
    meta: {title:'任务发布',cate:'操作中心'},
    children: [
        {
          path: 'import',
          component: () => import(/* webpackChunkName: "customer-list" */ '@/pages/customer/Import'),
          meta: {title:'导入数据'},
          hidden: true
        },
        {
          path: ':customer_id/view',
          component: () => import(/* webpackChunkName: "customer-view" */ '@/pages/customer/CreateEdit'),
          meta: {title:'查看结算清单'},
        },
        {
          path: 'exportpdf',
          component: () => import(/* webpackChunkName: "customer-view" */ '@/pages/customer/ExportPdf'),
          meta: {title:'导出协议', isShow: false},
        },
        {
		path: 'subexportpdf',
		component: () => import(/* webpackChunkName: "customer-view" */ '@/pages/customer/SubExportPdf'),
		meta: {title:'导出协议', isShow: false},
        },
        {
          path: 'exporth5pdf',
          component: () => import(/* webpackChunkName: "customer-view" */ '@/pages/customer/ExportH5Pdf'),
          meta: {title:'导出协议', isShow: false},
        },
		{
          path: 'exportpdf-HSY',
          component: () => import(/* webpackChunkName: "customer-view" */ '@/pages/customer/ExportPdfHSY'),
          meta: {title:'导出协议', isShow: false},
        }
      ]
}